"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookiesFromString = getCookiesFromString;
exports.getCookieFromString = getCookieFromString;
exports.getCookies = getCookies;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.array.slice.js");

/**
 * A CookieSource is a function that takes a context and returns an object
 * containing cookies. A source can also return null, indicating the source is
 * not available for the given context and the next source should be used. For
 * example, the "Node.js server request" source function returns null when
 * context.serverRequest is not present.
 *
 * Source functions can also return a promise if cookies are resolved
 * asynchronously.
 */

/**
 * Get a cookies object from the string found in document.cookie (also the
 * same as `Cookie` header strings).
 *
 * Adapted from http://stackoverflow.com/questions/10730362/get-cookie-by-name
 */
function getCookiesFromString(cookiesString) {
  return cookiesString.split(';').reduce(function (acc, cookieString) {
    var parts = cookieString.split('=');

    if (parts.length > 1) {
      acc[parts[0].trim()] = parts.slice(1).join('').trim();
    }

    return acc;
  }, {});
}
/**
 * Given a browser cookies string and the name of a cookie, returns the
 * corresponding cookie value, or `undefined` if the cookie was not present.
 */


function getCookieFromString(cookieName, cookiesString) {
  return getCookiesFromString(cookiesString)[cookieName];
}

var COOKIE_SOURCES = [function getFromConfig(context) {
  var _context$config, _context$config$getCo;

  return (_context$config = context.config) === null || _context$config === void 0 ? void 0 : (_context$config$getCo = _context$config.getCookies) === null || _context$config$getCo === void 0 ? void 0 : _context$config$getCo.call(_context$config, context);
}, function getFromServerRequest(context) {
  var _context$serverReques;

  return (_context$serverReques = context.serverRequest) === null || _context$serverReques === void 0 ? void 0 : _context$serverReques.cookies;
}, function getFromBrowserCookies() {
  // Safe access to window.document.cookie if it's available.
  if (typeof window !== 'undefined' && window.document) {
    return getCookiesFromString(window.document.cookie);
  }

  return undefined;
}];
/**
 * Calls each function in COOKIE_SOURCES in order until one of them returns a
 * truthy value. Returns the resolved cookies or an empty object if none of the
 * cookie sources returned a value.
 *
 * The primary motivation for this abstraction is to allow an application
 * running in a React Native environment to provide cookies from the
 * underlying iOS and Android systems.
 */

function getCookies(_x) {
  return _getCookies.apply(this, arguments);
}

function _getCookies() {
  _getCookies = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var i, maybePromise, resolvedCookies;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < COOKIE_SOURCES.length)) {
              _context.next = 11;
              break;
            }

            maybePromise = COOKIE_SOURCES[i](context);

            if (!maybePromise) {
              _context.next = 8;
              break;
            }

            _context.next = 6;
            return maybePromise;

          case 6:
            resolvedCookies = _context.sent;
            return _context.abrupt("return", resolvedCookies || {});

          case 8:
            i += 1;
            _context.next = 1;
            break;

          case 11:
            return _context.abrupt("return", {});

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getCookies.apply(this, arguments);
}